<div class="container" style="padding: 3em; white-space: pre-line">
  <div *ngIf="!data && !hasError">
    Lade...
    <app-loading-overlay></app-loading-overlay>
  </div>
  <div *ngIf="data">
    <img [src]="data.logoUrl" style="width: 300px; padding-bottom: 1em" />

    <h2>Installateurausweis: {{ data.passNummer }}</h2>

    <p>
      {{ data.introText }}
    </p>

    <p>
      <strong>Aussteller:</strong>
      <br />
      {{ data.companylocation?.contactData?.company }}
    </p>

    <p>
      <strong>Eingetragene Fachkraft:</strong>
      <br />
      {{ data.user.contactData.lastName }},
      {{ data.user.contactData.firstName }}
    </p>

    <p>
      <strong>Firma:</strong>
      <br />
      {{ data.user.businessPartner.contactData.company }}
      {{ data.user.businessPartner.contactData.companyAddition || '' }}
      {{ data.user.businessPartner.contactData.street }}
      {{ data.user.businessPartner.contactData.streetNo
      }}{{ data.user.businessPartner.contactData.streetNoAddition }}
      <br />
      {{ data.user.businessPartner.contactData.zipCode }}
      {{ data.user.businessPartner.contactData.city }}
    </p>

    <p>
      <strong>Gültig bis:</strong>
      <br />
      {{ data.expirationdate | date }}
    </p>

    <hr />
    <p>{{ data.footerCol1 }}</p>
  </div>

  <div *ngIf="hasError">Ein Fehler ist aufgetreten.</div>
</div>
